import axios from "axios";

const JonarAPI = process.env.JonarAPI;

class CurrencyService {
  getLatestCurrencies = async (): Promise<object[]> => {
    return await axios
      .post(
        `${JonarAPI}/currencies`,
        {},
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          withCredentials: true,
        }
      )
      .then((res) => {
        return res.data.ReturnItem.Data;
      });
  };
}

export default new CurrencyService();
